<template>
  <div class="pay-result">
    <div class="order-success flex-center flex-column" v-if="orderStatus == 'SUCCESS'">
      <van-icon name="checked" color="#07C160" size="54" />

      <div class="text">报名成功</div>

      <div>
        <van-button class="btn" color="#FF8534" plain square round @click="gotoOrderList"
          >查看订单</van-button
        >
        <van-button class="btn" color="#FF8534" plain square round @click="gotoHome">返回首页</van-button>
      </div>
    </div>

    <div class="order-fail" v-else-if="orderStatus == 'FAIL'">订单执行失败</div>

    <!-- <div class="pending">订单查询中...</div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageTitle: '报名成功',
      // 订单id
      id: this.$route.query.id,
      // 订单状态：SUCCESS-成功;PENDING-支付中;FAIL-失败
      orderStatus: '',
    };
  },
  methods: {
    gotoOrderList() {
      this.$router.push('/orderList');
    },
    gotoHome() {
      this.$router.push('/');
    },
    // 轮询订单状态
    getOrderStatus() {
      let _rsv,
        _rej,
        p = new Promise((resolve, reject) => {
          _rsv = resolve;
          _rej = reject;
        }),
        _this = this;

      (function getOrderStatusHandler(params) {
        _this.$api
          .getOrderStatus({
            orderId: _this.id,
          })
          .then(res => {
            console.log(res);
            if (res.code == 200) {
              _this.orderStatus = res.data.orderStatus;
              if (res.data.orderStatus == 'PENDING') {
                setTimeout(() => {
                  getOrderStatusHandler();
                }, 1000);
              } else {
                _rsv();
              }
            }
          });
      })();

      return p;
    },
  },
  async created() {
    vant.Toast.loading({
      message: '订单查询中...',
      forbidClick: true,
      loadingType: 'spinner',
      overlay: true,
      duration: 0,
    });
    await this.getOrderStatus();
    vant.Toast.clear();
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.order-success {
  padding-top: 115px;
  display: flex;
  flex-direction: column;
  .text {
    padding-top: 14px;
    padding-bottom: 42px;
    font-size: 17px;
    line-height: 24px;
    font-weight: bold;
  }
  .btn {
    margin: 0 20px;
    // width: 104px;
    height: 40px;
  }
}
</style>
